import { render, staticRenderFns } from "./Mutasi.vue?vue&type=template&id=2274882a"
import script from "./Mutasi.vue?vue&type=script&lang=js"
export * from "./Mutasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports